import { WritersPageLayout } from "../../pagelayouts/use-case/writers";
import { useMarketingPagesTracking } from "../../hooks/marketingPagesTracking";
import { GoogleTagManagerScript } from "../../tracking/GoogleTagManager/GoogleTagManagerScript";

const Writers = () => {
    useMarketingPagesTracking(true);

    return (
        <>
            <GoogleTagManagerScript />
            <WritersPageLayout />
        </>
    );
};

export async function getStaticProps() {
    return {
        props: {}
    };
}

export default Writers;
